import React from 'react';
import Footer from '../../components/general/footer/Footer';
import Navbar from '../../components/general/navbar/Navbar';
import Terms from '../../components/general/terms/Terms';
const TermsAndConditions = () => {
  return (
    <>
      <Navbar />
      <Terms />
      <Footer />
    </>
  );
};

export default TermsAndConditions;
